module.exports = __webpack_public_path__ + "static/media/space-3.6f670aa2.png";